var __vue_script__, __vue_template__
__vue_script__ = require("-!babel-loader?presets[]=es2015&plugins[]=transform-runtime!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./loading-dots.vue")
__vue_template__ = require("-!vue-html-loader!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./loading-dots.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/project/web/pattern-lab/source/scripts/components/loading-dots.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/components/loading-dots.vue
// module id = 22
// module chunks = 1 2 3 7 8 9 10 22